<sm-toolbar>
    <button pButton icon="fas fa-cog" label="Config zum automatisierten Verarbeiten erstellen" (click)="createConfig()"></button>
    @for (actionButton of actionButtons ?? []; track actionButton) {
        <button pButton [label]="actionButton.label" (click)="actionButton.command(null)"></button>
    }
</sm-toolbar>
<sm-table2 *ngIf="resultTable != null" class="flex-item-fill height100p " [data]="resultTable"></sm-table2>
<app-progressor-overlay [progressor]="progressor.value"></app-progressor-overlay>
